import { withTheme } from '../config';
import { Badge } from '@rneui/base/dist/Badge/Badge';
import { withBadge } from '@rneui/base/dist/Badge/withBadge';
export { Badge, withBadge };
export default withTheme(Badge, 'Badge');
